/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PhysicalCountUploadPreviewMetaDto = {
    sessionId: number;
    sessionCode: string;
    locationId: number;
    locationName: string;
    fileName: string;
    fileSizeBytes: number;
    parseModeApplied: PhysicalCountUploadPreviewMetaDto.parseModeApplied;
    normalizationApplied: PhysicalCountUploadPreviewMetaDto.normalizationApplied;
    uploadedAtIso: string;
};
export namespace PhysicalCountUploadPreviewMetaDto {
    export enum parseModeApplied {
        SINGLE_ROW = 'single_row',
        SINGLE_COLUMN = 'single_column',
    }
    export enum normalizationApplied {
        PRESERVE_CASE = 'preserve_case',
        UPPERCASE = 'uppercase',
    }
}

